/**
 * The SDX admin module backend to talk to. Mirrors the `server` union accepted by
 * both `@sodexo/admin-module-node` and `@sodexo/admin-module-react`, which each map
 * it to a concrete admin module URL.
 */
export type SdxAdminServer = 'sandbox_sdx' | 'dev_sdx' | 'uat_sdx' | 'prod_sdx' | 'local';

/**
 * Single source of truth mapping the app's `NODE_ENV` to the SDX admin module backend.
 *
 * We always pass the result explicitly to the admin module (web + server) instead of
 * relying on the SDK's own `NODE_ENV` fallback: the SDK uses different env-name
 * conventions than this app (e.g. it maps `development` to the sandbox backend), so
 * letting it default would make the server authorize against a different backend than
 * the web. Keeping the mapping here guarantees both stay in sync.
 */
export function getSdxAdminServer(nodeEnv: string | undefined = process.env.NODE_ENV): SdxAdminServer {
  switch (nodeEnv) {
    case 'local':
      return 'local';
    case 'development-sandbox':
      return 'sandbox_sdx';
    case 'development':
      return 'dev_sdx';
    case 'uat':
      return 'dev_sdx';
    default:
      return 'prod_sdx';
  }
}
